$(document).ready(function () {
    const customColors = $("#handle-color-orange, #handle-color-blue, #handle-color-red, #handle-color-green, #handle-color-white, #handle-color-yellow , #board-color-orange, #board-color-blue, #board-color-red, #board-color-green, #board-color-white, #board-color-yellow, #bumper-color-orange, #bumper-color-blue, #bumper-color-red, #bumper-color-green, #bumper-color-white, #bumper-color-yellow, #graphic-color-orange, #graphic-color-blue, #graphic-color-red, #graphic-color-green, #gear-color-black, #gear-color-orange, #gear-color-blue, #gear-color-red, #gear-color-green, #rail-color-orange, #rail-color-blue, #rail-color-red, #rail-color-green, #rail-color-grey");
    const standardColors = $('#handle-color-black, #board-color-black, #bumper-color-black, #gear-color-clear, #rail-color-black, #graphic-color-white');
    customColors.click(function() {
        $('#optional').click()
    });
    $('#standard').click(function() {
        standardColors.click()
    });
    $('#ski-mtn-top').click(function() {
        $('#handle-color-black, #board-color-black').click()
    });
    $('#handle-color-orange, #handle-color-blue, #handle-color-red, #handle-color-green, #handle-color-white, #handle-color-yellow , #board-color-orange, #board-color-blue, #board-color-red, #board-color-green, #board-color-white, #board-color-yellow, #bumper-color-orange, #bumper-color-blue').click(function() {
        $('#ski-yeti').click()
    });
    function updateBrakeOptionsnew() {
        if ($('#standard').is(':checked')) $('#custom-requires, .custom-color-require').show();
        else $('#custom-requires, .custom-color-require').hide();

        if ($('#ski-mtn-top').is(':checked')) $('#handle-requires, #board-requires').show();
        else $('#handle-requires, #board-requires').hide();
    }
  
    $("select[name^='properties'], input[name^='properties']").on(
      "change",
      function () {
        updateBrakeOptionsnew();
      }
    );
  });
  